// // DriveEmbedGallery.jsx
// import "./driveEmbedGallery.scss";

// const DriveEmbedGallery = () => {
//   const folderId = "1PdA4yJH0slwiNZxRZRB0gsW-caEtwMmE"; // your folder ID
//   const src = `https://drive.google.com/embeddedfolderview?id=${folderId}#grid`;

//   return (
//     <section className="drive-embed">
//       <div className="drive-embed__wrapper">
//         <div className="drive-embed__header">
//           <h2>Our Work Gallery</h2>
//           <p>
//             Images are loaded directly from our Google Drive folder. Whenever we
//             upload new photos there, they appear here automatically.
//           </p>
//         </div>

//         <div className="drive-embed__frame">
//           <iframe
//             src={src}
//             title="Google Drive gallery"
//             frameBorder="0"
//             scrolling="auto"
//           ></iframe>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default DriveEmbedGallery;

// DriveEmbedGallery.jsx
import "./driveEmbedGallery.scss";

const DriveEmbedGallery = () => {
  const folderId = "1PdA4yJH0slwiNZxRZRB0gsW-caEtwMmE"; // your folder ID
  const src = `https://drive.google.com/embeddedfolderview?id=${folderId}#grid`;

  return (
    <>
    <section className="drive-embed">
      <div className="drive-embed__wrapper">
        {/* <div className="drive-embed__header">
          <h2>Our Work Gallery</h2>
          <p>
            Images are loaded directly from our Google Drive folder. Whenever we
            upload new photos there, they appear here automatically.
          </p>
        </div> */}

        <div className="drive-embed__frame">
          <iframe
            src={src}
            title="Google Drive gallery"
            frameBorder="0"
            scrolling="auto"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
    
    

    </>
  );
};

export default DriveEmbedGallery;
